module.exports = __webpack_public_path__ + "img/kid-md.087ee14a.jpg";